export const fallbackSymbol = {
    emoji: 'star',
    emojiUnicode: '⭐️',
    colorToken: 'symbol-yellow-1'
}

export const blankSymbol = {
    emoji: 'memo',
    emojiUnicode: '📝',
    colorToken: 'symbol-green-1'
}

export const meetingLabels = {
    draft: {
        id: 'meeting_status_draft',
        defaultMessage: 'Draft'
    },
    open: {
        id: 'meeting_status_preparation',
        defaultMessage: 'Preparation'
    },
    conversation: {
        id: 'meeting_status_conversation',
        defaultMessage: 'Conversation'
    },
    closed: {
        id: 'meeting_status_completed',
        defaultMessage: 'Completed'
    }
}

export const meetingClassNames = {
    draft: 'neutral',
    open: 'passive',
    conversation: 'positive',
    closed: 'active'
}

export const meetingSubmitLabels = {
    draft: {
        id: 'action_save',
        defaultMessage: 'Save'
    },
    open: {
        id: 'meeting_action_prepare',
        defaultMessage: 'Go to Preparation'
    },
    conversation: {
        id: 'meeting_action_converse',
        defaultMessage: 'Go to Conversation'
    },
    closed: {
        id: 'meeting_action_complete',
        defaultMessage: 'Complete meeting'
    }
}

export const meetingConsequences = {
    draft: [
        {
            type: 'text',
            text: {
                id: 'meeting_status_option_draft',
                defaultMessage: 'Only you, as a meeting host, have access to this meeting.'
            }
        }
    ],
    open: [
        {
            type: 'boolean',
            value: true,
            text: {
                id: 'meeting_status_option_preparation_agenda',
                defaultMessage: 'Attendees will get invited and can contribute to the agenda.'
            }
        },
        {
            type: 'boolean',
            value: true,
            text: {
                id: 'meeting_status_option_preparation_notes',
                defaultMessage: 'Attendees can add notes to each talking point.'
            }
        },
        {
            type: 'boolean',
            value: true,
            text: {
                id: 'meeting_status_option_preparation_private_notes',
                defaultMessage: 'Attendees can add their own private notes.'
            }
        },
        {
            type: 'boolean',
            value: false,
            text: {
                id: 'meeting_status_option_preparation_summaries',
                defaultMessage: 'Attendees can’t see summaries or notes on talking points.'
            }
        }
    ],
    conversation: [
        {
            type: 'boolean',
            value: true,
            text: {
                id: 'meeting_status_option_conversation_notes',
                defaultMessage: 'Attendees’ notes on talking points will be shared with all attendees.'
            }
        },
        {
            type: 'boolean',
            value: false,
            text: {
                id: 'meeting_status_option_conversation_summaries',
                defaultMessage: 'Attendees can’t see summaries.'
            }
        }
    ],
    closed: [
        {
            type: 'boolean',
            value: true,
            text: {
                id: 'meeting_status_option_completed_summaries',
                defaultMessage: 'Summaries will be shared with all attendees.'
            }
        }
    ]
}
